import React from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';
import { withTranslation } from '@wix/yoshi-flow-editor';
import {
  ClosableOverlay,
  InfoOverlayAnimate,
  InfoOverlayWrapper,
  AllCardsClosableOverlay,
} from '@wix/wix-vod-shared/components';
import { focus } from '@wix/wix-vod-shared/widget';
import {
  areElementsRounded,
  isRTL,
} from '../../../../../selectors/app-settings';
import { getCompId } from '../../../../../redux/hydrated-data/hydrated-data';

import VideoInfo from '../../components/video-info/video-info';

import INFO_OVERLAY_CONTENT from './info-overlay-content-enums';

import styles from './animated-overlay-content.scss';

const mapStateToProps = (state, ownProps) => ({
  compId: getCompId(state),
  isVideoInfoVisible:
    ownProps.overlayContent === INFO_OVERLAY_CONTENT.VIDEO_INFO,
  isAllCardsVisible: ownProps.overlayContent === INFO_OVERLAY_CONTENT.ALL_CARDS,
  areElementsRounded: areElementsRounded(state),
  isRTL: isRTL(state),
});

export default withTranslation()(
  connect(mapStateToProps)(
    class AnimatedOverlayContent extends React.Component {
      static propTypes = {
        channelData: PropTypes.object,
        videoItem: PropTypes.object,
        allCardsOverlayContent: PropTypes.node,
        overlayContent: PropTypes.string,
        onClose: PropTypes.func,

        compId: PropTypes.string,

        isVideoInfoVisible: PropTypes.bool,
        isAllCardsVisible: PropTypes.bool,

        isPlayerInFullScreen: PropTypes.bool,
        areElementsRounded: PropTypes.bool,
        isRTL: PropTypes.bool,
      };

      static defaultProps = {
        onClose: _.noop,
      };

      componentDidUpdate(prevProps) {
        const { overlayContent } = this.props;

        if (!overlayContent && prevProps.overlayContent === overlayContent) {
          return;
        }

        const hasChangedToTrue = (key) => this.props[key] && !prevProps[key];

        if (hasChangedToTrue('isVideoInfoVisible')) {
          focus(this.videoInfoContainerRef);
        }

        if (hasChangedToTrue('isAllCardsVisible')) {
          focus(this.allCardsContainerRef);
        }
      }

      videoInfoContainerRef = null;
      allCardsContainerRef = null;

      saveVideoInfoContainerRef = (ref) => {
        this.videoInfoContainerRef = ref;
      };

      saveAllCardsContainerRef = (ref) => {
        this.allCardsContainerRef = ref;
      };

      render() {
        const {
          videoItem: {
            posterUrl,
            title,
            description,
            publisher,
            durationStr,
            genre,
            videoType,
            cast,
            crew,
          },
          allCardsOverlayContent,
          overlayContent,
          isPlayerInFullScreen,
          isVideoInfoVisible,
          isAllCardsVisible,
          onClose,
          isRTL,
        } = this.props;

        return (
          <InfoOverlayWrapper isActive={overlayContent}>
            <section
              className={styles['info-overlay-content']}
              aria-hidden={!isVideoInfoVisible}
              ref={this.saveVideoInfoContainerRef}
            >
              <InfoOverlayAnimate when={isVideoInfoVisible}>
                <ClosableOverlay
                  dataHook="closable-overlay"
                  onClose={onClose}
                  isInFullScreen={isPlayerInFullScreen}
                  posterUrl={posterUrl}
                  isVisible={isVideoInfoVisible}
                  isRTL={isRTL}
                  ariaLabel={this.props.t('widget.accessibility.video-info')}
                  closeButtonAriaLabel={this.props.t(
                    'widget.accessibility.close-video-info',
                  )}
                >
                  <VideoInfo
                    title={title}
                    description={description}
                    posterUrl={posterUrl}
                    publisher={publisher}
                    genre={genre}
                    videoType={videoType}
                    durationStr={durationStr}
                    durationAriaLabel={this.props.t(
                      'widget.accessibility.duration',
                      {
                        durationStr,
                      },
                    )}
                    cast={cast}
                    crew={crew}
                    isPlayerInFullScreen={isPlayerInFullScreen}
                    isRTL={isRTL}
                  />
                </ClosableOverlay>
              </InfoOverlayAnimate>
            </section>

            <section
              className={styles['info-overlay-content']}
              aria-hidden={!isAllCardsVisible}
              ref={this.saveAllCardsContainerRef}
            >
              <InfoOverlayAnimate when={isAllCardsVisible} type="fade-in">
                <AllCardsClosableOverlay
                  dataHook="all-cards-overlay"
                  onClose={onClose}
                  isVisible={isAllCardsVisible}
                  isFullWidth
                  isFullWidthForced
                  isInFullScreen={isPlayerInFullScreen}
                  isRTL={isRTL}
                  closeOnBodyClick
                  ariaLabel={this.props.t('widget.accessibility.all-cards')}
                  closeButtonAriaLabel={this.props.t(
                    'widget.accessibility.close-all-cards',
                  )}
                >
                  {isAllCardsVisible && allCardsOverlayContent}
                </AllCardsClosableOverlay>
              </InfoOverlayAnimate>
            </section>
          </InfoOverlayWrapper>
        );
      }
    },
  ),
);
